<div class="vendor-management">
  <div class="container">
    <div class="dashboard-header">
      <div class="left-section">
        <h1>Vendor Management</h1>
      </div>
      <div class="right-section">
        <app-button-group
          *ngIf="false"
          [label]="'Quarterly Feedback'"
          [buttonType]="'Primary'"
          (onEmit)="navigateToQuarterlyFeedback()"
          style="padding-right: 15px;"
        ></app-button-group>
        <emerald-button [type]="'Primary'" [label]="'Contractor Hiring'" [size]="'Medium'" [icon]="'arrow_drop_down'"
          [iconFillType]="'filled'" (onClick)="toggleModal()" [iconPosition]="'Right'"></emerald-button>
        <div class="dropdown-modal" *ngIf="isModalOpen" [style]="{
            position: 'absolute',
            top: '100%',
            right: '0',
            zIndex: '1000',
            marginTop: '1px',
          }">
          <ul class="dropdown-list">
            <li (click)="handleOptionClick('open-positions')">
              Open Positions
            </li>
            <li (click)="handleOptionClick('raise-hiring-request')">
              Raise Hiring Request
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="dashboard">
      <div class="grid-layout">
        <!-- Left Section: Interview Status -->
        <div class="left-section">
          <!-- Add your Interview Status component here -->
          <div class="interview-status-container">
            <app-interview-status-widget [hiringIds]="hiringIds"></app-interview-status-widget>
          </div>
        </div>

        <!-- Middle Section: Positions & Contractor Headcount -->
        <div class="middle-section">
          <div class="positions-container">
            <app-positions (hiringIdsReady)="hiringIds = $event"></app-positions>
          </div>
          <div class="contractor-headcount-container">
            <app-contractor-head-count></app-contractor-head-count>
          </div>
        </div>

        <!-- Right Section: Top Vendors -->
        <div class="right-section">
          <div class="top-vendors">
            <app-doughnut></app-doughnut>
          </div>
        </div>
      </div>

      <div class="timesheet-container" id="timesheet-section">
        <app-timesheet></app-timesheet>
      </div>
      <!-- <div class="expiring-contracts-container">
        <app-expiring-contracts-dashboard></app-expiring-contracts-dashboard>
      </div>
      <div class="skills-container">
        <app-skills></app-skills>
      </div> -->
    </div>